<div [attr.id]="idProp">
    <div class="modal-header">
        <h4 class="modal-title">{{ "user.create.modal.role.title" | translate }}</h4>
        <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
    </div>
    <div class="modal-body" [formGroup]="grantsForm">
        @if (AdaaHelper.isPMOEntity()) {
            <div class="d-flex justify-content-end">
                <adaa-form-checkbox
                    controlName="isAdvancedMode"
                    formControlName="isAdvancedMode"
                    [useSwitch]="true"
                    [label]="'user.create.modal.role.advancedMode' | translate"
                    (inputChanges)="resetForm()"
                />
            </div>
        }
        @if (grantsForm.get("isAdvancedMode")?.value) {
            <div class="row">
                <div class="col-12">
                    <adaa-form-dropdown-multi
                        formControlName="entities"
                        controlName="entities"
                        [label]="'common.form.label.entity' | translate"
                        [options]="entities"
                        [clearable]="true"
                        [allowSelectAll]="true"
                        (inputChanges)="advancedGrantsChanged()"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <adaa-form-two-way-select
                        #grantsSelectAdvanced
                        notSelectedLabel="user.create.modal.role.avaliableroles"
                        selectedLabel="user.create.modal.role.userroles"
                        formControlName="grantsAdvanced"
                        controlName="grantsAdvanced"
                        [options]="advancedGrantsOptions()"
                        (inputChanges)="advancedGrantsChanged()"
                    />
                </div>
            </div>
        } @else {
            @if (AdaaHelper.isPMOEntity()) {
                <div class="row">
                    <div class="col-12">
                        <adaa-form-dropdown
                            formControlName="entityId"
                            controlName="entityId"
                            [label]="'common.form.label.entity' | translate"
                            [options]="entities"
                            [clearable]="true"
                            (inputChanges)="entityIdChanged($event)"
                        />
                    </div>
                </div>
            }
            <div class="row">
                <div class="col-12">
                    <adaa-form-dropdown-tree
                        formControlName="orgUnitId"
                        controlName="orgUnitId"
                        [label]="'user.create.modal.role.organizationunit' | translate"
                        [options]="orgUnitsOptions()"
                        (inputChanges)="orgUnitIdChanged()"
                    />
                    @if (isDsV2() && grantsForm.get("orgUnitId")!.value !== null) {
                        <label class="text-warning text-center fw-bold"> {{ "user.create.modal.role.organizationUnitWarning" | translate }} </label>
                    }
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <adaa-form-two-way-select
                        #grantsSelect
                        notSelectedLabel="user.create.modal.role.avaliableroles"
                        selectedLabel="user.create.modal.role.userroles"
                        formControlName="grants"
                        controlName="grants"
                        [options]="grantsOptions()"
                        (inputChanges)="grantsChanged($event)"
                    />
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.close()">{{ "common.form.button.close" | translate }}</button>
        <button type="button" class="btn btn-primary" (click)="save()">{{ "common.form.button.save" | translate }}</button>
    </div>
</div>
